import * as React from 'react'

import { Colors, Cross } from '@giantleap/components-library'
import { Button } from '@material-ui/core'
import Avatar from '@material-ui/core/Avatar'
import classnames from 'classnames'
import ReactSVG from 'react-svg'
import { getDefaultAvatar } from 'services/avatar'
import InfoIcon from '../../assets/img/info-icon.svg'
import './style.scss'

import { INativeChildProps } from 'data/child'

export interface IProps extends INativeChildProps {
  openInfoModal?: React.MouseEventHandler<HTMLDivElement>
  hasInfo?: boolean
}

const Children = (props: IProps) => {
  const {
    childrenName,
    childrenAge,
    childrenPhoto,
    className,
    childrenGender,
    onClick,
    onDelete,
    openInfoModal,
    hasInfo
  } = props

  const [crossSize, setCrossSize] = React.useState<'big' | 'small'>('big')

  const onResize = () => {
    if (window && window.innerWidth <= 360) {
      setCrossSize('small')
    } else {
      setCrossSize('big')
    }
  }

  React.useEffect(() => {
    onResize()
    window.addEventListener('resize', onResize)
    return () => {
      window.removeEventListener('resize', onResize)
    }
  }, [])

  return (
    <div
      className={
        'children-content-wrapper' + (className ? ` ${className}` : '')
      }
      onClick={() => onClick()}
    >
      {onDelete && (
        <Button
          className="delete-button disconnect-child-button"
          onClick={(e: React.MouseEvent<HTMLElement, MouseEvent>) => {
            onDelete()
            e.stopPropagation()
          }}
        >
          <Cross size={crossSize} color={Colors.paleBrightPurple} />
        </Button>
      )}
      {/*if there will be only svg => then use ReactSVG*/}
      {/* <ReactSVG 
        className={classnames(
          'children-photo',
          !childrenPhoto && 'default-avatar'
          )}
          src={childrenPhoto || getDefaultAvatar(childrenGender)}
        /> */}
      <div className="children-content-body">
        <Avatar
          className={classnames(
            'children-photo',
            !childrenPhoto && 'default-avatar'
          )}
          src={childrenPhoto || getDefaultAvatar(childrenGender)}
        />
        <div className="info">
          <div className="children-name">
            {hasInfo && (
              <div
                className="children-icon"
                onClick={event => openInfoModal && openInfoModal(event)}
              >
                <ReactSVG src={InfoIcon} />
              </div>
            )}
            {childrenName}
          </div>
          {childrenAge !== null && childrenAge !== undefined ? (
            <div className="children-age">Age: {childrenAge} years</div>
          ) : null}
        </div>
      </div>
    </div>
  )
}

const WithHOCs = Children

export default (props: IProps) => <WithHOCs {...props} />



// WEBPACK FOOTER //
// ./src/components/Children/index.tsx